import { Box, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import {
    darkYellow,
    lightYellow,
    topUpChipStyle,
    topUpChipText,
} from "src/pages/balancePage/BalancePage.style";
import { TopUpOptions } from "./WalletTopUp";

type TopUpChipButtonType = {
    children: TopUpOptions;
    activeValue: TopUpOptions;
    setActiveChipButton: Dispatch<SetStateAction<TopUpOptions>>;
};

const TopUpChipButton = ({
    children,
    activeValue,
    setActiveChipButton,
}: TopUpChipButtonType) => {
    return (
        <Box
            justifyContent="center"
            alignItems="center"
            onClick={() => {
                setActiveChipButton(children);
            }}
            sx={{
                ...topUpChipStyle,
                bgcolor: activeValue === children ? darkYellow : lightYellow,
            }}
        >
            <Typography sx={topUpChipText}>$ {children}</Typography>
        </Box>
    );
};

export default TopUpChipButton;
